import { developer2025Plan } from './developer2025Plan';
import { developerPlan } from './developerPlan';
import { foundation2025Plan } from './foundation2025Plan';
import { foundation2025PlanPostTrial } from './foundation2025PlanPostTrial';
import { foundationPlan } from './foundationPlan';
import { foundationPlanPostTrial } from './foundationPlanPostTrial';
import { guardianPlan } from './guardianPlan';
import { planIdToPlan } from './planIdToPlan';

export {
  developerPlan,
  foundationPlan,
  guardianPlan,
  foundationPlanPostTrial,
  developer2025Plan,
  foundation2025Plan,
  foundation2025PlanPostTrial,
};
export { AI_RUNS_DESCRIPTION } from './products';

// TODO the plan version should eventually be toggled by a flag
export const VERSION = 1;
export const OBSERVABILITY_VERSION = 2;

export const allPlans = [
  developerPlan,
  foundationPlan,
  guardianPlan,
  foundationPlanPostTrial,
  developer2025Plan,
  foundation2025Plan,
  foundation2025PlanPostTrial,
];
export const trialPlans = [developerPlan, foundationPlan, guardianPlan];
export const trialPlans2025 = [developer2025Plan, foundationPlan, guardianPlan];
export const postTrialPlans = [foundationPlanPostTrial, guardianPlan];
export const postTrialPlans2025 = [developer2025Plan, foundationPlanPostTrial, guardianPlan];
export { planIdToPlan };
